export default "__VITE_ASSET__ab35b77c__"